import React from "react";

function SearchInput(_ref) {
  var getAutocomplete = _ref.getAutocomplete,
      getButtonProps = _ref.getButtonProps,
      getInputProps = _ref.getInputProps;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "sui-search-box__wrapper"
  }, /*#__PURE__*/React.createElement("input", getInputProps()), getAutocomplete()), /*#__PURE__*/React.createElement("input", getButtonProps()));
}

export default SearchInput;